import { ThreadPrimitive } from '@assistant-ui/react';
import { IconArrowDown } from '@tabler/icons-react';

import { TooltipIconButton } from '../tooltip-icon-button/TooltipIconButton.tsx';

/** Floating button that scrolls the chat thread to the latest message. */
export function ThreadScrollToBottom() {
  return (
    <ThreadPrimitive.ScrollToBottom asChild>
      <TooltipIconButton position="top" radius="100%" size="md" tooltip="Scroll to bottom" variant="outline">
        <IconArrowDown size={16} />
      </TooltipIconButton>
    </ThreadPrimitive.ScrollToBottom>
  );
}
